import * as React from "react";
import { Button, TextField, FormHelperText, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { checkCodeForUseInfluencerRegisterApi } from "../../../../../services/marketingApi";
import { registerStep2Api } from "../../../../../services/InfluencerApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

function RegisterCode(props) {
  const { situationCode, influencerId, handlesetInfluencerTabsValue } = props;
  const [checkCode, setCheckCode] = React.useState("initial");
  const [marketingCode, setMarketingCode] = React.useState("");
  const [tokenForRegister, setTokenForRegister] = React.useState("");

  const handleCode = (value) => {
    setMarketingCode(value)
  }

  const checkInfluencerCode = async () => {
    if (marketingCode.length == 0) {
      customToastify("error", "لطفا کد را وارد کنید");
    } else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        const data = { marketingCode, influencerId }
        const response = await checkCodeForUseInfluencerRegisterApi(data);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setCheckCode("ready")
          setTokenForRegister(resData["data"]["data"][0]["codeToken"])
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
        setCheckCode("ready")

      } catch (error) {

        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
        console.error(error);
      }
    }
  };


  const registerSubmit = async () => {
    if (tokenForRegister.length == 0) {
      customToastify("error", "لطفا ابتدا بر روی دکمه بررسی کلیک کنید");
    } else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        const data = { presenterCodeToken: tokenForRegister }
        const response = await registerStep2Api(data);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          // setCheckCode("ready")
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
        // setCheckCode("ready")

      } catch (error) {

        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
        console.error(error);
      }
    }
  };



  return (
    <Paper>
      {situationCode == "initialRegistration" ?
        <>
          <TextField size="small"
            disabled={checkCode !== "initial"}
            label="کد همکاری"
            variant="outlined"
            onChange={(e) => {
              handleCode(e.target.value)
            }}
          />
          <Typography sx={{ fontSize: "medium" }}>
            ابتدا بر روی بررسی و سپس ثبت کد کلیک کنید
          </Typography>
          <Typography onClick={() => { handlesetInfluencerTabsValue(null, 1) }} sx={{ mb: 1, fontSize: "smaller", textDecoration: "underline", cursor: "pointer" }}>
            چنانچه کد همکاری ندارید اینجا کلیک کنید
          </Typography>
          <Button sx={{ m: 1 }} disabled={checkCode !== "initial"} variant="contained"
            onClick={checkInfluencerCode}
          >
            بررسی
          </Button>
          <Button sx={{ m: 1 }} disabled={checkCode == "initial"} variant="contained"
            onClick={registerSubmit}>
            ثبت کد
          </Button>
        </>
        :
        <>
        </>

      }

    </Paper>
  );
}

export default RegisterCode;
